import { useTranslation } from 'react-i18next'

import { SEARCH_RESULTS_BUILDINGS_ENTITY } from '../../../constants/entity'
import {
  ROUTE_PATH_LIST,
  SUBMENU_DEFAULT_VALUE,
} from '../../../constants/route'
import { BuildingTableLayout, useBuildingTablePage } from '../../Building'
import { useSearchResultsTableOptions } from '../SearchResults.hooks'
import { getSearchResultsBreadcrumbs } from '../SearchResults.utils'
import { SearchResultsPage } from '../SearchResultsPage'

import { updateSearchResultsBuildingsTableConfig } from './SearchResultsBuildings.api'
import {
  QA_NAME_SEARCH_RESULTS_BUILDINGS_TABLE,
  SEARCH_RESULTS_BUILDINGS_CONFIG_API,
  SEARCH_RESULTS_BUILDINGS_LIST_API,
} from './SearchResultsBuildings.constants'

import BuildingsIcon from '../../../icons/building.svg'

function SearchResultsBuildings() {
  const { t } = useTranslation()

  const { asyncTableOptions, extraSelectionResetDeps, searchQuery } =
    useSearchResultsTableOptions({
      asyncTableOptions: {
        listApi: SEARCH_RESULTS_BUILDINGS_LIST_API,
        tableConfigApi: SEARCH_RESULTS_BUILDINGS_CONFIG_API,
      },
    })

  const tablePage = useBuildingTablePage({
    asyncTableOptions,
    entity: SEARCH_RESULTS_BUILDINGS_ENTITY,
    extraSelectionResetDeps,
    pageTitle: t('SearchResults.BuildingsBrowserTabTitleKey'),
    sub: SUBMENU_DEFAULT_VALUE,
    onApplyTableConfig: updateSearchResultsBuildingsTableConfig,
  })

  const breadcrumbs = getSearchResultsBreadcrumbs({
    leadingBreadcrumbs: [
      {
        id: 'buildings',
        title: t('BrowserTab.BuildingsPageTitleKey'),
        to: `/${ROUTE_PATH_LIST.buildings}/`,
      },
    ],
    searchQuery,
    t,
  })

  return (
    <SearchResultsPage
      EntityIcon={BuildingsIcon}
      TableLayout={BuildingTableLayout}
      breadcrumbs={breadcrumbs}
      emptyText={t('Building.NoDataKey')}
      qaName={QA_NAME_SEARCH_RESULTS_BUILDINGS_TABLE}
      tablePage={tablePage}
    />
  )
}

export default SearchResultsBuildings
